import purple from '@mui/material/colors/purple';
import { createTheme, adaptV4Theme } from '@mui/material/styles';

const defaultTheme = createTheme(adaptV4Theme({
  palette: {
    mode: 'dark',

    primary: {
      main: '#000',
      contrastText: '#e3f2fd',
    },
    secondary: {
      main: purple[100],
    },
    contrastThreshold: 3,
    tonalOffset: 0.03,
  },
}));

export default defaultTheme;
